// AboutMe.js
import React from 'react';

const AboutMe = () => {
  return <div></div>;
};

export default AboutMe;
